import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

const ScrollToTop: React.FC = () => {
  // hooks
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// TODO : apply to auth pages
const AuthLayout: React.FC = () => {
  // renders
  return (
    <div className="w-full min-h-screen overflow-x-hidden flex flex-col items-center">
      <ScrollToTop />
      <Outlet />
    </div>
  );
};

export default AuthLayout;
